import { apiGet } from './auth'

export interface ProductVariant {
  name: string
  count: number
  price_eur: number
  total_price_eur: number
}

export interface ProductRow {
  kind: 'product' | 'fee'
  product_id: number | null
  product_fee_id: number | null
  external_id: string | null
  name: string
  category_id: number | null
  category: string | null
  quantity: number
  revenue_eur: number
  discount_eur: number
  orders: number
  average_price_eur: number
  share_pct: number
  vat_rates: number[]
  store_codes: string[]
  variants: ProductVariant[]
}

export interface ProductStore {
  store_id: number
  store_code: string
  store_name: string
  available: boolean
  business_id: number | null
  timezone: string | null
  currency: string | null
  order_rows: number
  pages_fetched: number
  skipped_orders: number
  orders_found: number
  orders_included: number
  product_lines: number
  fee_lines: number
  missing_order_lines: number
  truncated: boolean
  error_code: string | null
  error_message: string | null
}

export interface ProductTotals {
  product_revenue_eur: number
  fee_revenue_eur: number
  line_total_eur: number
  refunds_eur: number
  discount_eur: number
  orders: number
  quantity: number
  products: number
  fees: number
}

export interface ProductOverviewResponse {
  start_date: string
  end_date: string
  days: number
  currency: string
  timezone: string
  source: 'butlaroo_orders_order_lines'
  aggregation: 'order_lines'
  sales_basis: 'line_unit_price_ex_vat'
  refunds_available: boolean
  discounted_unit_price: boolean
  modifier_prices_in_line_price: boolean
  stores: ProductStore[]
  products: ProductRow[]
  fees: ProductRow[]
  totals: ProductTotals
  order_rows: number
  order_lines: number
  variant_rows: number
  pages_fetched: number
  warnings: string[]
  truncated: boolean
  fetched_at: string
}

export interface ProductOverviewParams {
  from: string
  to: string
  /** Omit to let the server use the account's whole entitled scope. */
  storeIds?: number[]
  signal?: AbortSignal
}

/**
 * Live product mix from paid Butlaroo order lines. The server enforces
 * capability and store scope; this client only sends dates and shops.
 */
export function fetchProductOverview({
  from,
  to,
  storeIds,
  signal,
}: ProductOverviewParams): Promise<ProductOverviewResponse> {
  return apiGet<ProductOverviewResponse>(
    '/butlaroo/product-overview',
    {
      start_date: from,
      end_date: to,
      store_ids: storeIds && storeIds.length > 0 ? storeIds : undefined,
    },
    signal,
  )
}
